<div class="col-xs-1">
  <div [hidden]="hideBinaryOperator">
    <label *ngIf="searchExpression.BinaryOperator == 0">{{
      'shared.widgets.expression.binary-operator.and' | translate | titlecase
    }}</label>
    <label *ngIf="searchExpression.BinaryOperator == 1">{{ 'shared.widgets.expression.binary-operator.or' | translate | titlecase }}</label>
  </div>
</div>
<div class="col-xs-2">
  {{ searchExpression.Field | wlRegexReplace: '([a-z])([A-Z])':'g':'$1 $2' }}
</div>
<div class="col-xs-2">
  <label *ngIf="searchExpression.FieldValueOperator == 0">{{
    'shared.widgets.expression.value-operator.equals' | translate | titlecase
  }}</label>
  <label *ngIf="searchExpression.FieldValueOperator == 1">{{
    'shared.widgets.expression.value-operator.contains' | translate | titlecase
  }}</label>
  <label *ngIf="searchExpression.FieldValueOperator == 2">{{
    'shared.widgets.expression.value-operator.not-equal' | translate | titlecase
  }}</label>
  <label *ngIf="searchExpression.FieldValueOperator == 3">{{
    'shared.widgets.expression.value-operator.greater-than' | translate | titlecase
  }}</label>
  <label *ngIf="searchExpression.FieldValueOperator == 4">{{
    'shared.widgets.expression.value-operator.less-than' | translate | titlecase
  }}</label>
  <label *ngIf="searchExpression.FieldValueOperator == 5">{{
    'shared.widgets.expression.value-operator.in-the-period' | translate | titlecase
  }}</label>
  <label *ngIf="searchExpression.FieldValueOperator == 7">{{
    'shared.widgets.expression.value-operator.number-of-days-until' | translate | titlecase
  }}</label>
  <label *ngIf="searchExpression.FieldValueOperator == 8">{{
    'shared.widgets.expression.value-operator.number-of-days-since' | translate | titlecase
  }}</label>
</div>
<div class="col-xs-2" *ngIf="searchExpression.FieldValueOperator != 5">
  {{ searchExpression.Value }}
</div>
<div class="col-xs-5" *ngIf="searchExpression.FieldValueOperator == 5">
  <label *ngIf="searchExpression.Value == datePeriodEnum.Last1Day">{{
    'shared.widgets.expression.date-period-options.last-1-day' | translate | titlecase
  }}</label>
  <label *ngIf="searchExpression.Value == datePeriodEnum.Last7Days">{{
    'shared.widgets.expression.date-period-options.last-7-days' | translate | titlecase
  }}</label>
  <label *ngIf="searchExpression.Value == datePeriodEnum.Last30Days">{{
    'shared.widgets.expression.date-period-options.last-30-days' | translate | titlecase
  }}</label>
  <label *ngIf="searchExpression.Value == datePeriodEnum.MonthToDate">{{
    'shared.widgets.expression.date-period-options.month-to-date' | translate | titlecase
  }}</label>
  <label *ngIf="searchExpression.Value == datePeriodEnum.YearToDate">{{
    'shared.widgets.expression.date-period-options.year-to-date' | translate | titlecase
  }}</label>
  <label *ngIf="searchExpression.Value == datePeriodEnum.Next7Days">{{
    'shared.widgets.expression.date-period-options.next-7-days' | translate | titlecase
  }}</label>
  <label *ngIf="searchExpression.Value == datePeriodEnum.Next30Days">{{
    'shared.widgets.expression.date-period-options.next-30-days' | translate | titlecase
  }}</label>
  <label *ngIf="searchExpression.Value == datePeriodEnum.Next60Days">{{
    'shared.widgets.expression.date-period-options.next-60-days' | translate | titlecase
  }}</label>
</div>
